import { IClientComponentDefinition } from '@glidecms/deliver-core-dev/gd-module'

export const WEmbedGalleryCCD: IClientComponentDefinition = {
  name: 'WEmbedGallery',
  load: () => import(/* webpackChunkName: 'WEmbedGallery' */ './index'),
}
